import React from "react";

import Container from "@/components/Container";
import { GridColumns } from "@/components/Container/Container.interface";
import { ComponentProps } from "@/helpers/componentProps";

import styles from "./Section.module.scss";

export const SimpleSection: React.FC<ComponentProps> = ({ children }) => (
  <div className={styles.simpleSection}>
    <Container grid={GridColumns.Three}>{children}</Container>
  </div>
);

export default SimpleSection;
